// Favourites: a design the salon likes, kept so the next one takes a tap.
// What's kept is the look (kind of post, style, colours, fonts, size, name or
// logo, format) and the salon's own framing words (a small heading, the last
// line), never the facts a new post will have fresh: prices, times, names,
// reviews, tips.
import { POST_TYPES, makePost, designName } from './postTypes'
import { FAMILIES } from '../render/families'
import { colourwaysFor } from '../render/colourways'

// The words worth keeping, per kind of post
const FRAME = ['eyebrow', 'label', 'cta', 'note']
const KEEP_ALSO = {
  freeSlots: ['headline'],
  oneSlot: ['headline', 'line'],
  freshWork: ['headline'],
  beforeAfter: ['headline'],
  giftVouchers: ['headline'],
  priceList: ['title'],
}

export const favouriteFrom = (post) => {
  const def = POST_TYPES[post.type]
  const keep = [...FRAME, ...(KEEP_ALSO[post.type] || [])]
  const words = {}
  def.fields.forEach((f) => {
    if (!keep.includes(f.key) || !(post.touched || {})[f.key]) return
    const v = post.content && post.content[f.key]
    if (typeof v === 'string' && v.trim()) words[f.key] = v
  })
  const out = { type: post.type, family: post.family || 'editorial', colourway: post.colourway, format: post.format || 'post', words }
  if (post.family === 'layouts' && post.layout) out.layout = post.layout
  if (post.tune && Object.keys(post.tune).length) out.tune = post.tune
  if (post.colourway === 'photo' && post.photoColour) out.photoColour = post.photoColour
  return out
}

// A new post in a favourite's design
export const postFromFavourite = (fav, { trade = 'hair', brandColour } = {}) => {
  const post = makePost(fav.type, { trade, family: fav.family, colourway: fav.colourway, layout: fav.layout, brandColour, format: fav.format, content: fav.words || {} })
  return {
    ...post,
    ...(fav.tune ? { tune: fav.tune } : {}),
    ...(fav.photoColour ? { photoColour: fav.photoColour } : {}),
    favouriteId: fav.id,
  }
}

// "Before and after" / "The real result, blush"
export const favouriteNames = (fav, { brandColour } = {}) => {
  const way = colourwaysFor(fav.family, { brandColour, photoColour: fav.photoColour }).find(w => w.id === fav.colourway)
  const colours = fav.tune && fav.tune.colours ? 'your colours' : way ? way.name.toLowerCase() : ''
  return {
    title: POST_TYPES[fav.type].label,
    design: [designName(fav.type, fav.family, fav.layout) || (FAMILIES[fav.family] || {}).name, colours].filter(Boolean).join(', '),
  }
}
